import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import LoyaltyProgramNameLogo from 'loyalty/components/LoyaltyProgramNameLogo'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const HeroSection = styled.div`
  padding: ${rem(60)} 0;
  background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
`

interface Props {
  onActivate?: () => void
}

function LoyaltyUserStayUpgradePromoGoldHero(props: Props) {
  const { onActivate } = props
  const firstName = useAppSelector(state => state.auth.account.givenName)

  return <HeroSection>
    <LayoutContainer variant="medium" style={{ zIndex: 1 }}>
      <VerticalSpacer gap={16} style={{ position: 'relative' }}>
        <Group direction="horizontal" gap={12}>
          <LoyaltyProgramNameLogo width={104} />
          <LoyaltyTierLabel kind="primary" tier="gold">
            EXCLUSIVE INVITE
          </LoyaltyTierLabel>
        </Group>
        <Group
          direction="vertical"
          tabletDirection="horizontal"
          tabletHorizontalAlign="space-between"
          gap={24}
          tabletGap={16}
        >
          <VerticalSpacer gap={16}>
            <Heading variant="heading1" format="propercase">
              {firstName && <><i>{firstName}</i>, you’ve got 2 free upgrades</>}
              {!firstName && <>You’ve got 2 free upgrades</>}
            </Heading>
            <Heading variant="heading4">
              Your fast-tracked Gold status now includes 2 free room or package upgrades. Activate for instant access to all Gold status benefits.
            </Heading>
          </VerticalSpacer>
          <Group
            direction="vertical"
            horizontalAlign="start"
            tabletHorizontalAlign="end"
            tabletVerticalAlign="end"
          >
            <TextButton kind="primary" onClick={onActivate}>
              Activate your free membership
            </TextButton>
          </Group>
        </Group>
      </VerticalSpacer>
    </LayoutContainer>
  </HeroSection>
}

export default LoyaltyUserStayUpgradePromoGoldHero
